import { Checkbox } from '@fluentui/react-components';
import styled from 'styled-components';

const activeStyles = `
  border: 1.3px solid #cecece;
  border-radius: 0.25rem;
  box-shadow: 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.11), 0px 3.2px 7.8px 0px rgba(0, 0, 0, 0.13);
  padding: 0.4rem;
  width: 90%;
  margin: auto;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;
export const TableSelect = styled.div<{
  inputStylePicker?: boolean;
  position?: string;
}>`
  font-size: 11px;
  font-weight: 700;
  color: ${(props) => props.theme.tableHeadFont};
  background: ${(props) => {
    if (!props.inputStylePicker) {
      return props.theme.tableHeadColor;
    } else {
      return props.theme.tableSelectInput;
    }
  }};
  ${(props) => {
    if (props.inputStylePicker) {
      return activeStyles;
    }
  }};
`;

export const TableOptionsContainer = styled.ul<{
  right?: string;
  left?: string;
  width?: string;
  scrollable?: boolean;
  position?: string;
  optionContainerPadding?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: baseline;
  background: ${(props) => props.theme.tableOptionsBackground};
  color: ${(props) => props.theme.tableOptionsColor};
  top: 29px;
  padding: 0;
  min-width: ${({ width }) => (width ? width : '120px')};
  max-height: 210px;
  overflow-y: ${({ scrollable }) => (scrollable ? 'scroll' : 'visible')};
  overflow-x: visible;
  z-index: 100;
  box-shadow: 0px 0.6px 1.8px 0px rgba(0, 0, 0, 0.11),
    0px 3.2px 7.8px 0px rgba(0, 0, 0, 0.13);
  ::-webkit-scrollbar {
    width: 3px;
  }
  position: absolute;
  color: ${({ theme }) => theme.textMainColor};
  right: ${({ right }) => (right ? right : 'unset')};
  left: ${({ left }) => (left ? left : 'unset')};
`;

export const TableOption = styled.li`
  list-style: none;
  font-size: 10px;
  font-weight: 400;
  height: 24px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  color: ${({ theme }) => theme.textMainColor};
  :hover {
    background: ${(props) => props.theme.tableOptionHover};
  }
`;

export const FilterAXSOption = styled.li`
  list-style: none;
`;

export const FilterAXSCheckbox = styled(Checkbox)<{ fontSize?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  margin: 0;
  object-fit: contain;
  box-sizing: border-box;
  height: 35px;
  [class*='fui-Checkbox__indicator'] {
    margin-top: 0.6rem;
  }
  span {
    width: 100%;
    object-fit: contain;
    box-sizing: border-box;
    display: flex;

    div {
      position: relative;
      align-self: center;
      justify-self: center;
    }
  }
  li {
    padding: 0;
    margin: 0;
    width: 100%;
    object-fit: contain;
    box-sizing: border-box;
  }
  label {
    width: 100%;
    object-fit: contain;
    box-sizing: border-box;
    text-align: left;
    font-size: 10px;
    padding: 0;
    margin: 0;
    color: ${({ theme }) => theme.textMainColor};
  }
`;

export const FilterHeader = styled.p`
  color: ${({ theme }) => theme.textMainColor};
  border-bottom: 2px solid ${({ theme }) => theme.tableHeadDivider};
  padding: 0.25rem;
  width: 100%;
  text-align: start;
`;
